<template>
  <div class="home hideScrollbar">
    <div class="main max-width">
      <div class="title">1DING GRC</div>
      <div class="description show-xs-and-up-only">
        <p>一丁工作室致力于将 1DING.CN 打造成信息科技风险与安全管理的360度工作平台, 将提供包括但不限于知识库、管理制度、技术措施、流程运转、合规评价等多项功能。</p>
        <p>2019年4月15日，标准与法规的精准搜索功能的上线试运行，后续将持续上线新的功能，敬请期待。</p>
      </div>
      <div class="subtitle show-xs-down-only">
        <p>致力于成为最实用、最全面的 IT GRC 平台</p>
      </div>
      <div class="button_group">
        <el-row>
          <el-col
            :span="2"
            style="height:0.6rem;line-height:0.6rem;text-align:center"
          >
            <i
              class="el-icon-caret-left"
              size="25"
              @click="changeItem('left')"
            ></i>
          </el-col>
          <el-col :span="20">
            <el-row :gutter="10">
              <el-col :span="8">
                <button
                  class="button"
                  @click="router(menuItem[0])"
                >
                  <span class="show-xs-and-up-only">{{menuItem[0].label_1}}</span>
                  <span class="show-xs-down-only">{{menuItem[0].label_2}}</span>
                </button>
              </el-col>
              <el-col :span="8">
                <button
                  class="button"
                  @click="router(menuItem[1])"
                >
                  <span class="show-xs-and-up-only">{{menuItem[1].label_1}}</span>
                  <span class="show-xs-down-only">{{menuItem[1].label_2}}</span>
                </button>
              </el-col>
              <el-col :span="8">
                <button
                  class="button"
                  @click="router(menuItem[2])"
                >
                  <span class="show-xs-and-up-only">{{menuItem[2].label_1}}</span>
                  <span class="show-xs-down-only">{{menuItem[2].label_2}}</span>
                </button>
              </el-col>
            </el-row>
          </el-col>
          <el-col
            :span="2"
            style="height:0.6rem;line-height:0.6rem;text-align:center"
          >
            <i
              class="el-icon-caret-right"
              size="25"
              @click="changeItem('right')"
            />
          </el-col>
        </el-row>
      </div>
      <div class="button_group">
        <el-row :gutter="10">
          <el-col
            :span="1"
            style="height: 0.6rem;line-height:0.6rem"
          ></el-col>
          <el-col :span="22">
            <input
              type="text"
              class="input"
              v-model="keywords"
              placeholder="输入关键字，搜索对应的标准或法规"
            >
          </el-col>
          <el-col :span="1"></el-col>
        </el-row>
      </div>
      <div class="button_group">
        <button
          class="button_search_left"
          @click="search('standards')"
        >找标准</button>
        <button
          class="button_search_right"
          @click="search('regulations')"
        >找法规</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      params: "yes",
      view: "",
      views: "",
      keywords: "",
      searchArea: "standards",
      menuItem: [
        {
          label_1: "国内标准 / 国际标准",
          label_2: "标准库",
          name: "standards",
          path: "/tech"
        },
        {
          label_1: "法律法规 / 监管要求",
          label_2: "法规库",
          name: "regulations",
          path: "/tech"
        },
        {
          label_1: "高级搜索 / 精准搜索",
          label_2: "精准搜索",
          name: "advance_search",
          path: "advanceSearch"
        },
        {
          label_1: "技术专题 / 1DING专栏",
          label_2: "技术专题",
          name: "tech_1ding",
          path: "/tech"
        }
      ]
    };
  },
  methods: {
    // 控制菜单项（按钮）左右滚动
    changeItem(params) {
      if (params == "right") {
        var tempL = this.menuItem.shift();
        this.menuItem.push(tempL);
      } else {
        var tempR = this.menuItem.pop();
        this.menuItem.unshift(tempR);
      }
    },
    // 点击菜单项（按钮）在新页面打开对应的内容
    router(params) {
      const { href } = this.$router.resolve({
        path: params.path
      });
      window.open(href, "_blank");
    },
    // 点击搜索按钮，启动搜索
    search(params) {
      if (this.keywords && this.keywords.replace(/\s*/g, "").length > 1) {
        if (params == "standards") {
          const { href } = this.$router.resolve({
            path: "/searchStandardsTitle",
            query: {
              // 如果有人按照精准搜索进行输入，则转换成常规搜索
              keywords: this.keywords
                .replace(/：/g, ":")
                .replace(/，/g, ",")
                .replace(/：/g, ":")
                .replace(/'[cCiIoOsSyYnN]:'/, "")
            }
          });
          window.open(href, "_blank");
        }
        if (params == "regulations") {
          const { href } = this.$router.resolve({
            path: "/searchRegulationsTitle",
            query: {
              // 如果有人按照精准搜索进行输入，则转换成常规搜索
              keywords: this.keywords
                .replace(/：/g, ":")
                .replace(/，/g, ",")
                .replace(/：/g, ":")
                .replace(/'[cCiIoOsSyYnN]:'/, "")
            }
          });
          window.open(href, "_blank");
        }
      } else {
        alert("您输入的搜索关键字太短");
      }
    }
  }
};
</script>

<style scoped>
* {
  font-size: 0.12rem;
  line-height: 0.24rem;
}

.home {
  width: 100%;
  height: 100vh;
  background-color: #2f2f2f;
  color: #efefef;
  /*垂直居中*/
  display: flex;
  display: -webkit-flex;
  flex-direction: column;
  text-align: center;
  justify-content: center;
}

.home .main {
  /* 水平居中 */
  width: 100%;
  max-width: 8rem;
  margin: 0 auto;
}

.home .view {
  position:absolute;
  top: 0.1rem;
  left: 0.1rem;
  text-align: center;
  font-size: 0.1rem;
  font-weight: 200;
  letter-spacing: 0.01rem;
}

.home .title {
  text-align: center;
  font-size: 0.3rem;
  font-weight: 900;
}

.home .description {
  margin: 0.3rem 0 1.2rem 0;
  text-align: center;
  letter-spacing: 0.01rem;
}

.home .subtitle {
  text-align: center;
  margin: 0.1rem auto;
}

.home .button_group {
  margin: 0.3rem 0;
  text-align: center;
}

.home .button {
  width: 100%;
  height: 0.6rem;
  margin: 0;
  padding: 0;
  background-color: transparent;
  border: solid 1px #efefef;
  border-radius: 0.3rem;
  outline: none;
  color: #efefef;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.01rem;
}

.home .button:hover {
  cursor: pointer;
  background-color: #aa0000 !important;
  color: white;
}

.home .button_search_left {
  background-color: #aa0000;
  border: solid 1px #efefef;
  border-radius: 0.4rem 0 0 0.4rem;
  color: #efefef;
  outline: none;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.01rem;
  display: inline-block;
  margin: 0.1rem 0 0.1rem 0.1rem;
  width: 0.9rem;
  height: 0.6rem;
}

.home .button_search_right {
  background-color: #aa0000;
  border: solid 1px #efefef;
  border-radius: 0 0.4rem 0.4rem 0;
  color: #efefef;
  outline: none;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.01rem;
  display: inline-block;
  margin: 0.1rem 0.1rem 0.1rem 0;
  width: 0.9rem;
  height: 0.6rem;
}

.home .button_search_left:hover,
.home .button_search_right:hover {
  cursor: pointer;
  background-color: red !important;
}

.home .input {
  background-color: white;
  border: solid 1px #aa0000;
  border-radius: 0.4rem;
  outline: none;
  color: black;
  text-align: center;
  text-decoration: none;
  letter-spacing: 0.01rem;
  width: 100%;
  height: 0.6rem;
  margin: 0.3rem 0;
}
</style>